import { render, staticRenderFns } from "./GraficoPluviosidade.vue?vue&type=template&id=5d8d3d42&lang=pug"
import script from "./GraficoPluviosidade.vue?vue&type=script&lang=js"
export * from "./GraficoPluviosidade.vue?vue&type=script&lang=js"
import style0 from "./GraficoPluviosidade.vue?vue&type=style&index=0&id=5d8d3d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports